var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-auto" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default btn-lg",
            on: { click: _vm.chooseFile }
          },
          [
            _vm._v(
              "\r\n                " +
                _vm._s(
                  _vm.resource(
                    "DmVisualizer_ChangeInfo_Select_Logo_Button_Text"
                  )
                ) +
                "\r\n            "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6 preview", attrs: { align: "center" } }, [
        _c("input", {
          ref: "upload",
          attrs: {
            type: "file",
            id: "file-upload",
            name: "file-upload",
            accept: "image/*",
            hidden: ""
          },
          on: { change: _vm.uploadFile }
        }),
        _vm._v(" "),
        _c("img", {
          ref: "image",
          attrs: { name: "image-preview", id: "image-preview" }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }